<div class="events-resume" style="overflow-y: auto;"
    (scroll)="onScroll($event)">
    <div class="sidebar-sticky-header">
        <div class="d-flex justify-content-between align-items-center">
            <div class="go-back" (click)="goBack()"
                style="cursor: pointer; padding: 10px;">
                <i class="fa-sharp fa-thin fa-arrow-left"></i>
                <span>Eventos</span>
            </div>
            <div class="filter-toggle" (click)="showFilters=!showFilters"
                [class.active]="showFilters || searchText || fromDate">
                <i class="fal fa-sliders-h"></i>
            </div>
        </div>

        <!-- Filtros compactos -->
        <div class="sidebar-filters" *ngIf="showFilters">
            <div class="sidebar-searchbar">
                <i class="fal fa-search"></i>
                <input type="text" [value]="searchText" (input)="onSearchChange($any($event.target).value)"
                    placeholder="Buscar...">
                <i class="fal fa-times clear-inline" *ngIf="searchText" (click)="searchText=''; onSearchChange('')"></i>
            </div>
            <div class="sidebar-actions-row">
                <div class="sidebar-date-wrapper" #fechaDropdown>
                    <div class="sidebar-date-trigger" (click)="toggleDatePicker()"
                        [class.active]="fromDate">
                        <i class="fal fa-calendar"></i>
                        <span class="date-label" *ngIf="!stringDate">Fecha</span>
                        <span class="date-label" *ngIf="stringDate">{{ stringDate }}</span>
                        <i class="fal fa-angle-down arrow-icon"></i>
                    </div>
                </div>
                <div class="sidebar-clear" (click)="clearFilters()" *ngIf="fromDate">
                    <i class="fal fa-times"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- Calendario flotante fuera del scroll -->
    <div class="calendar-dropdown-fixed" *ngIf="openDatePicker" [ngStyle]="calendarStyle">
        <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1" [dayTemplate]="t"
            outsideDays="visible" (dateSelect)="changeDate($event)" [minDate]="minDate"
            (navigate)="dateNavigate($event)">
            <ng-template #t let-date let-focused="focused">
                <span class="custom-day" [class.focused]="fromDate != null && hoveredDate != null"
                    [class.first-select]="isFromDate(date)" [class.last-select]="isToDate(date)"
                    [class.faded]="isHovered(date) || isInside(date)"
                    [class.border-monday]="isMonday(date)" [class.border-sunday]="isSunday(date)"
                    [class.range]="isRange(date)" [class.day-disabled]="isDisabled(date)"
                    (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                    <span class="inside-day" [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                </span>
            </ng-template>
        </ngb-datepicker>
    </div>

    <div style="margin-top: 12px; padding: 4px; border-radius: 24px;"
        *ngFor="let event of eventCards"
        [ngStyle]="(eventId==event.id) && {'border': '2px solid #FF4D80'}">

        <div>
            <app-events-horizontal-card
                [event]="event"></app-events-horizontal-card>
        </div>
    </div>

    <div class="loading-spinner" *ngIf="loadingSpinner">
        <mat-progress-spinner color="accent" mode="indeterminate" diameter="40">
        </mat-progress-spinner>
    </div>

</div>